function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.6 18.9166C18.6 17.8906 17.8884 17.0281 16.9333 16.7953V13.0833C16.9333 12.3389 16.3277 11.7333 15.5833 11.7333H3.91667C3.17227 11.7333 2.56667 12.3389 2.56667 13.0833V16.7953C1.61156 17.0281 0.9 17.8906 0.9 18.9166V21.4166V25.5833C0.9 25.8685 1.13144 26.0999 1.41667 26.0999H3.08333C3.36856 26.0999 3.6 25.8685 3.6 25.5833V24.4333H15.9V25.5833C15.9 25.8685 16.1314 26.0999 16.4167 26.0999H18.0833C18.3686 26.0999 18.6 25.8685 18.6 25.5833V21.4166V18.9166ZM3.6 13.0833C3.6 12.9089 3.74231 12.7666 3.91667 12.7666H15.5833C15.7577 12.7666 15.9 12.9089 15.9 13.0833V16.7333H15.2667V15.1666C15.2667 14.4222 14.6611 13.8166 13.9167 13.8166H11.4167C10.6723 13.8166 10.0667 14.4222 10.0667 15.1666V16.7333H9.43333V15.1666C9.43333 14.4222 8.82773 13.8166 8.08333 13.8166H5.58333C4.83894 13.8166 4.23333 14.4222 4.23333 15.1666V16.7333H3.6V13.0833ZM14.2333 15.1666V16.7333H11.1V15.1666C11.1 14.9922 11.2423 14.8499 11.4167 14.8499H13.9167C14.091 14.8499 14.2333 14.9922 14.2333 15.1666ZM8.4 15.1666V16.7333H5.26667V15.1666C5.26667 14.9922 5.40898 14.8499 5.58333 14.8499H8.08333C8.25769 14.8499 8.4 14.9922 8.4 15.1666ZM17.5667 25.0666H16.9333V23.9166C16.9333 23.6314 16.7019 23.3999 16.4167 23.3999H3.08333C2.7981 23.3999 2.56667 23.6314 2.56667 23.9166V25.0666H1.93333V21.9333H17.5667V25.0666ZM17.5667 20.8999H1.93333V18.9166C1.93333 18.2826 2.4494 17.7666 3.08333 17.7666H4.75H8.91667H10.5833H14.75H16.4167C17.0506 17.7666 17.5667 18.2826 17.5667 18.9166V20.8999Z",
  fill: "url(#paint0_linear)",
  stroke: "url(#paint1_linear)",
  strokeWidth: 0.2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.2333 23.5V23.6H19.3333H20.1666H20.2666V23.5V21.1H25.0666V23.5V23.6H25.1666H25.9999H26.0999V23.5V20.5834V17.25C26.0999 16.9648 25.8685 16.7334 25.5833 16.7334H19.7499C19.4647 16.7334 19.2333 16.9648 19.2333 17.25V20.5834V23.5ZM25.0666 20.0667H20.2666V17.7667H25.0666V20.0667Z",
  fill: "url(#paint2_linear)",
  stroke: "url(#paint3_linear)",
  strokeWidth: 0.2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.5999 18.5V18.4H23.4999H21.8333H21.7333V18.5V19.3333V19.4333H21.8333H23.4999H23.5999V19.3333V18.5Z",
  fill: "url(#paint4_linear)",
  stroke: "url(#paint5_linear)",
  strokeWidth: 0.2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.6712 13.7434L24.7523 13.8018C24.8495 13.667 24.8758 13.494 24.8236 13.3365L24.8236 13.3363L23.9902 10.8363L23.9902 10.8361C23.9194 10.6255 23.7226 10.4834 23.4999 10.4834H21.8333C21.6106 10.4834 21.4137 10.6256 21.343 10.8366L21.343 10.8368L20.5097 13.3367C20.5097 13.3367 20.5097 13.3367 20.5097 13.3367C20.5097 13.3367 20.5097 13.3367 20.5097 13.3368C20.4569 13.4946 20.4839 13.6676 20.5809 13.8022C20.6781 13.9372 20.8341 14.0167 20.9999 14.0167H22.1499V15.0667H21.4166H21.3166V15.1667V16V16.1H21.4166H23.9166H24.0166V16V15.1667V15.0667H23.9166H23.1833V14.0167H24.3333C24.4991 14.0167 24.6552 13.9371 24.7524 13.8017L24.6712 13.7434ZM24.6712 13.7434C24.5929 13.8525 24.467 13.9167 24.3333 13.9167H23.1833L24.7287 13.368C24.7708 13.495 24.7495 13.6346 24.6712 13.7434ZM23.1279 11.5167L23.6166 12.9834H21.7166L22.2058 11.5167H23.1279Z",
  fill: "url(#paint6_linear)",
  stroke: "url(#paint7_linear)",
  strokeWidth: 0.2
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.7948 6.36172L25.7947 6.36167L13.7113 0.944999L13.711 0.944869C13.5765 0.885066 13.4232 0.885002 13.2888 0.944927L13.2887 0.944999L1.20534 6.36167L1.20521 6.36172C1.0194 6.44534 0.9 6.62974 0.9 6.83333V11.8333V11.9333H1H1.83333H1.93333V11.8333V7.16768L13.5 1.98292L25.0667 7.16809V11.8333V11.9333H25.1667H26H26.1V11.8333V6.83333C26.1 6.62974 25.9806 6.44534 25.7948 6.36172Z",
  fill: "url(#paint8_linear)",
  stroke: "url(#paint9_linear)",
  strokeWidth: 0.2
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.4748 6.74768L16.4583 6.64899L16.3596 6.66559L15.5375 6.80393L15.4385 6.82058L15.4555 6.91951C15.4741 7.0274 15.4833 7.13838 15.4833 7.25004C15.4833 8.34356 14.5934 9.23337 13.4999 9.23337C12.4064 9.23337 11.5166 8.34356 11.5166 7.25004C11.5166 6.15652 12.4064 5.26671 13.4999 5.26671C13.727 5.26671 13.9499 5.30481 14.1616 5.37973L14.2559 5.41312L14.2892 5.31875L14.5667 4.53292L14.6 4.43869L14.5058 4.40535C14.1829 4.29111 13.8445 4.23337 13.4999 4.23337C11.8364 4.23337 10.4833 5.58648 10.4833 7.25004C10.4833 8.9136 11.8364 10.2667 13.4999 10.2667C15.1635 10.2667 16.5166 8.9136 16.5166 7.25004C16.5166 7.08114 16.5024 6.91228 16.4748 6.74768Z",
  fill: "url(#paint10_linear)",
  stroke: "url(#paint11_linear)",
  strokeWidth: 0.2
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.1928 4.38473L16.1221 4.31402L16.0514 4.38473L13.5 6.9361L13.0319 6.46807L12.9612 6.39735L12.8905 6.46807L12.3014 7.05723L12.2306 7.12794L12.3014 7.19865L13.1347 8.03199C13.2354 8.1327 13.3678 8.18336 13.5 8.18336C13.6322 8.18336 13.7646 8.1327 13.8653 8.03199L16.7819 5.11532L16.8527 5.04461L16.7819 4.9739L16.1928 4.38473Z",
  fill: "url(#paint12_linear)",
  stroke: "url(#paint13_linear)",
  strokeWidth: 0.2
});

var _ref8 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 4.71762,
  y1: 11.8333,
  x2: 16.526,
  y2: 14.0382,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 4.71762,
  y1: 11.8333,
  x2: 16.526,
  y2: 14.0382,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 20.7495,
  y1: 16.8334,
  x2: 25.3008,
  y2: 17.5214,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 20.7495,
  y1: 16.8334,
  x2: 25.3008,
  y2: 17.5214,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 22.1873,
  y1: 18.5,
  x2: 23.2537,
  y2: 18.8224,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 22.1873,
  y1: 18.5,
  x2: 23.2537,
  y2: 18.8224,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 21.4683,
  y1: 10.5834,
  x2: 24.3391,
  y2: 10.9172,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 21.4683,
  y1: 10.5834,
  x2: 24.3391,
  y2: 10.9172,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 6.31088,
  y1: 1,
  x2: 21.8744,
  y2: 6.4291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 6.31088,
  y1: 1,
  x2: 21.8744,
  y2: 6.4291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 11.8225,
  y1: 4.33337,
  x2: 15.8048,
  y2: 4.93536,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 11.8225,
  y1: 4.33337,
  x2: 15.8048,
  y2: 4.93536,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 13.2939,
  y1: 4.45544,
  x2: 16.228,
  y2: 4.98592,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 13.2939,
  y1: 4.45544,
  x2: 16.228,
  y2: 4.98592,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/end1.d1354c8a.svg";
export { SvgComponent as ReactComponent };